import type * as Types from "../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUserSubscriptionQueryVariables = Types.Exact<{
  getUserSubscriptionInput: Types.GetUserSubscriptionInput;
}>;

export type GetUserSubscriptionQuery = {
  __typename?: "Query";
  getUserSubscription: {
    __typename?: "UserSubscription";
    uuid: string;
    chargeInterval: number | null;
    intervalType: string;
    amount: number;
    nextCharge: string | null;
    plan: { __typename?: "SubscriptionPlan"; uuid: string; name: string };
    discount: {
      __typename?: "Discount";
      discountUuid: string;
      amount: number;
      name: string;
      discountType: {
        __typename?: "DiscountType";
        discountType: Types.DiscountTypeValue;
      };
    } | null;
  };
};

export type CurrentUserSubscriptionFragment = {
  __typename?: "UserSubscription";
  uuid: string;
  chargeInterval: number | null;
  intervalType: string;
  amount: number;
  nextCharge: string | null;
  plan: { __typename?: "SubscriptionPlan"; uuid: string; name: string };
  discount: {
    __typename?: "Discount";
    discountUuid: string;
    amount: number;
    name: string;
    discountType: {
      __typename?: "DiscountType";
      discountType: Types.DiscountTypeValue;
    };
  } | null;
};

export type GetCalendarItemTypesQueryVariables = Types.Exact<{
  active?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GetCalendarItemTypesQuery = {
  __typename?: "Query";
  getCalendarClassTypes: Array<{
    __typename?: "CalendarClassType";
    uuid: string;
    name: string;
  }>;
};

export type CalendarItemTypeFragment = {
  __typename?: "CalendarClassType";
  uuid: string;
  name: string;
};

export type GetInvoicePreviewForSwitchUserSubscriptionQueryVariables =
  Types.Exact<{
    getInvoicePreviewForSwitchUserSubscriptionInput: Types.GetInvoicePreviewForSwitchUserSubscriptionInput;
  }>;

export type GetInvoicePreviewForSwitchUserSubscriptionQuery = {
  __typename?: "Query";
  getInvoicePreviewForSwitchUserSubscription: {
    __typename?: "InvoicePreviewForSwitchUserSubscription";
    unusedBalance: number;
    isChargeable: boolean;
    subtotal: number;
    total: number;
    proration: {
      __typename?: "NewUserSubscriptionProration";
      dailyPrice: number;
      remainingDays: number;
      newPlanProratedCost: number;
    } | null;
    discount: {
      __typename?: "InvoiceDiscount";
      rate: number;
      type: string;
      amount: number;
    } | null;
    tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
    fees: Array<{
      __typename?: "InvoiceFee";
      rate: number | null;
      fee: number;
      description: string | null;
      code: Types.InvoiceFeeCode;
    }> | null;
  };
};

export type GetInvoicePreviewForPlanQueryVariables = Types.Exact<{
  getInvoicePreviewForPlanInput: Types.GetInvoicePreviewForPlanInput;
}>;

export type GetInvoicePreviewForPlanQuery = {
  __typename?: "Query";
  getInvoicePreviewForPlan: {
    __typename?: "InvoicePreview";
    totalMinusPostFees: number;
    subtotal: number;
    total: number;
    totalRecurring: number | null;
    discount: {
      __typename?: "InvoiceDiscount";
      rate: number;
      type: string;
      amount: number;
    } | null;
    discountRecurring: {
      __typename?: "InvoiceDiscount";
      rate: number;
      type: string;
      amount: number;
    } | null;
    tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
    taxRecurring: {
      __typename?: "InvoiceTax";
      amount: number;
      rate: number;
    } | null;
    fees: Array<{
      __typename?: "InvoiceFee";
      rate: number | null;
      fee: number;
      description: string | null;
      code: Types.InvoiceFeeCode;
    }> | null;
    feesRecurring: Array<{
      __typename?: "InvoiceFee";
      rate: number | null;
      fee: number;
      description: string | null;
      code: Types.InvoiceFeeCode;
    }> | null;
  };
};

export type SwitchUserSubscriptionMutationVariables = Types.Exact<{
  switchUserSubscriptionInput: Types.SwitchUserSubscriptionInput;
}>;

export type SwitchUserSubscriptionMutation = {
  __typename?: "Mutation";
  switchUserSubscription:
    | {
        __typename?: "SwitchUserSubscriptionBillingFailedResult";
        message: string;
      }
    | { __typename?: "SwitchUserSubscriptionBillingNeedActionResult" }
    | { __typename?: "SwitchUserSubscriptionFailedResult"; message: string }
    | { __typename?: "SwitchUserSubscriptionSuccessResult"; message: string };
};

export const CurrentUserSubscriptionFragmentDoc = gql`
  fragment CurrentUserSubscription on UserSubscription {
    uuid
    chargeInterval
    intervalType
    chargeInterval
    amount
    nextCharge
    plan {
      uuid
      name
    }
    discount {
      discountUuid
      amount
      name
      discountType {
        discountType
      }
    }
  }
`;
export const CalendarItemTypeFragmentDoc = gql`
  fragment CalendarItemType on CalendarClassType {
    uuid
    name
  }
`;
export const GetUserSubscriptionDocument = gql`
  query GetUserSubscription(
    $getUserSubscriptionInput: GetUserSubscriptionInput!
  ) {
    getUserSubscription(getUserSubscriptionInput: $getUserSubscriptionInput) {
      ...CurrentUserSubscription
    }
  }
  ${CurrentUserSubscriptionFragmentDoc}
`;

/**
 * __useGetUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionQuery({
 *   variables: {
 *      getUserSubscriptionInput: // value for 'getUserSubscriptionInput'
 *   },
 * });
 */
export function useGetUserSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserSubscriptionQuery,
    GetUserSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserSubscriptionQuery,
    GetUserSubscriptionQueryVariables
  >(GetUserSubscriptionDocument, options);
}
export function useGetUserSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserSubscriptionQuery,
    GetUserSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserSubscriptionQuery,
    GetUserSubscriptionQueryVariables
  >(GetUserSubscriptionDocument, options);
}
export type GetUserSubscriptionQueryHookResult = ReturnType<
  typeof useGetUserSubscriptionQuery
>;
export type GetUserSubscriptionLazyQueryHookResult = ReturnType<
  typeof useGetUserSubscriptionLazyQuery
>;
export type GetUserSubscriptionQueryResult = Apollo.QueryResult<
  GetUserSubscriptionQuery,
  GetUserSubscriptionQueryVariables
>;
export const GetCalendarItemTypesDocument = gql`
  query GetCalendarItemTypes($active: Boolean) {
    getCalendarClassTypes(active: $active) {
      ...CalendarItemType
    }
  }
  ${CalendarItemTypeFragmentDoc}
`;

/**
 * __useGetCalendarItemTypesQuery__
 *
 * To run a query within a React component, call `useGetCalendarItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarItemTypesQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCalendarItemTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCalendarItemTypesQuery,
    GetCalendarItemTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarItemTypesQuery,
    GetCalendarItemTypesQueryVariables
  >(GetCalendarItemTypesDocument, options);
}
export function useGetCalendarItemTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarItemTypesQuery,
    GetCalendarItemTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarItemTypesQuery,
    GetCalendarItemTypesQueryVariables
  >(GetCalendarItemTypesDocument, options);
}
export type GetCalendarItemTypesQueryHookResult = ReturnType<
  typeof useGetCalendarItemTypesQuery
>;
export type GetCalendarItemTypesLazyQueryHookResult = ReturnType<
  typeof useGetCalendarItemTypesLazyQuery
>;
export type GetCalendarItemTypesQueryResult = Apollo.QueryResult<
  GetCalendarItemTypesQuery,
  GetCalendarItemTypesQueryVariables
>;
export const GetInvoicePreviewForSwitchUserSubscriptionDocument = gql`
  query GetInvoicePreviewForSwitchUserSubscription(
    $getInvoicePreviewForSwitchUserSubscriptionInput: GetInvoicePreviewForSwitchUserSubscriptionInput!
  ) {
    getInvoicePreviewForSwitchUserSubscription(
      getInvoicePreviewForSwitchUserSubscriptionInput: $getInvoicePreviewForSwitchUserSubscriptionInput
    ) {
      proration {
        dailyPrice
        remainingDays
        newPlanProratedCost
      }
      discount {
        rate
        type
        amount
      }
      tax {
        amount
        rate
      }
      fees {
        rate
        fee
        description
        code
      }
      unusedBalance
      isChargeable
      subtotal
      total
    }
  }
`;

/**
 * __useGetInvoicePreviewForSwitchUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewForSwitchUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewForSwitchUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewForSwitchUserSubscriptionQuery({
 *   variables: {
 *      getInvoicePreviewForSwitchUserSubscriptionInput: // value for 'getInvoicePreviewForSwitchUserSubscriptionInput'
 *   },
 * });
 */
export function useGetInvoicePreviewForSwitchUserSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicePreviewForSwitchUserSubscriptionQuery,
    GetInvoicePreviewForSwitchUserSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInvoicePreviewForSwitchUserSubscriptionQuery,
    GetInvoicePreviewForSwitchUserSubscriptionQueryVariables
  >(GetInvoicePreviewForSwitchUserSubscriptionDocument, options);
}
export function useGetInvoicePreviewForSwitchUserSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicePreviewForSwitchUserSubscriptionQuery,
    GetInvoicePreviewForSwitchUserSubscriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInvoicePreviewForSwitchUserSubscriptionQuery,
    GetInvoicePreviewForSwitchUserSubscriptionQueryVariables
  >(GetInvoicePreviewForSwitchUserSubscriptionDocument, options);
}
export type GetInvoicePreviewForSwitchUserSubscriptionQueryHookResult =
  ReturnType<typeof useGetInvoicePreviewForSwitchUserSubscriptionQuery>;
export type GetInvoicePreviewForSwitchUserSubscriptionLazyQueryHookResult =
  ReturnType<typeof useGetInvoicePreviewForSwitchUserSubscriptionLazyQuery>;
export type GetInvoicePreviewForSwitchUserSubscriptionQueryResult =
  Apollo.QueryResult<
    GetInvoicePreviewForSwitchUserSubscriptionQuery,
    GetInvoicePreviewForSwitchUserSubscriptionQueryVariables
  >;
export const GetInvoicePreviewForPlanDocument = gql`
  query GetInvoicePreviewForPlan(
    $getInvoicePreviewForPlanInput: GetInvoicePreviewForPlanInput!
  ) {
    getInvoicePreviewForPlan(
      getInvoicePreviewForPlanInput: $getInvoicePreviewForPlanInput
    ) {
      discount {
        rate
        type
        amount
      }
      discountRecurring {
        rate
        type
        amount
      }
      tax {
        amount
        rate
      }
      taxRecurring {
        amount
        rate
      }
      fees {
        rate
        fee
        description
        code
      }
      feesRecurring {
        rate
        fee
        description
        code
      }
      totalMinusPostFees
      subtotal
      total
      totalRecurring
    }
  }
`;

/**
 * __useGetInvoicePreviewForPlanQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewForPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewForPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewForPlanQuery({
 *   variables: {
 *      getInvoicePreviewForPlanInput: // value for 'getInvoicePreviewForPlanInput'
 *   },
 * });
 */
export function useGetInvoicePreviewForPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicePreviewForPlanQuery,
    GetInvoicePreviewForPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInvoicePreviewForPlanQuery,
    GetInvoicePreviewForPlanQueryVariables
  >(GetInvoicePreviewForPlanDocument, options);
}
export function useGetInvoicePreviewForPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicePreviewForPlanQuery,
    GetInvoicePreviewForPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInvoicePreviewForPlanQuery,
    GetInvoicePreviewForPlanQueryVariables
  >(GetInvoicePreviewForPlanDocument, options);
}
export type GetInvoicePreviewForPlanQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForPlanQuery
>;
export type GetInvoicePreviewForPlanLazyQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForPlanLazyQuery
>;
export type GetInvoicePreviewForPlanQueryResult = Apollo.QueryResult<
  GetInvoicePreviewForPlanQuery,
  GetInvoicePreviewForPlanQueryVariables
>;
export const SwitchUserSubscriptionDocument = gql`
  mutation SwitchUserSubscription(
    $switchUserSubscriptionInput: SwitchUserSubscriptionInput!
  ) {
    switchUserSubscription(
      switchUserSubscriptionInput: $switchUserSubscriptionInput
    ) {
      ... on SwitchUserSubscriptionSuccessResult {
        message
      }
      ... on SwitchUserSubscriptionFailedResult {
        message
      }
      ... on SwitchUserSubscriptionBillingFailedResult {
        message
      }
    }
  }
`;
export type SwitchUserSubscriptionMutationFn = Apollo.MutationFunction<
  SwitchUserSubscriptionMutation,
  SwitchUserSubscriptionMutationVariables
>;

/**
 * __useSwitchUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useSwitchUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchUserSubscriptionMutation, { data, loading, error }] = useSwitchUserSubscriptionMutation({
 *   variables: {
 *      switchUserSubscriptionInput: // value for 'switchUserSubscriptionInput'
 *   },
 * });
 */
export function useSwitchUserSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchUserSubscriptionMutation,
    SwitchUserSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SwitchUserSubscriptionMutation,
    SwitchUserSubscriptionMutationVariables
  >(SwitchUserSubscriptionDocument, options);
}
export type SwitchUserSubscriptionMutationHookResult = ReturnType<
  typeof useSwitchUserSubscriptionMutation
>;
export type SwitchUserSubscriptionMutationResult =
  Apollo.MutationResult<SwitchUserSubscriptionMutation>;
export type SwitchUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  SwitchUserSubscriptionMutation,
  SwitchUserSubscriptionMutationVariables
>;
